// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MapResults-mapCanvas-hgyBU {
	height: 100%;
	width: 100%;
	background-color: var(--secondary-gray-bg);
	overflow: hidden;
	position: relative;
}

.MapResults-customMarkerContainer-xtoUN {
	position: relative;
	display: inline-block;
	margin-top: -8px;
}

.MapResults-customMarkerContent-nRGaX {
	font-size: 14px;
	line-height: 24px;
	letter-spacing: normal;
	color: var(--primary-foreground);
	font-weight: 500;
	background-color: var(--background-primary);
	-webkit-box-shadow: 0px 2px 4px 0px var(--primary-box-shadow);
	        box-shadow: 0px 2px 4px 0px var(--primary-box-shadow);
	position: relative;
	border-width: 1px !important;
	border-style: solid !important;
	border-color: var(--primary-border) !important;
	-o-border-image: initial !important;
	   border-image: initial !important;
	border-radius: 20px !important;
	padding: 4px 8px 4px 8px !important;
	font-family: var(--font-family-base) !important;
	width: -webkit-max-content;
	width: -moz-max-content;
	width: max-content;
}

.MapResults-customMarkerPoint-QGrmu {
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
	background-color: var(--background-primary);
	width: 8px;
	height: 8px;
	-webkit-transform: rotate(45deg);
	    -ms-transform: rotate(45deg);
	        transform: rotate(45deg);
	position: absolute;
	border-color: var(--primary-border) !important;
	border-style: solid !important;
	border-width: 0px 1px 1px 0px !important;
}

.MapResults-customMarkerPointBorder-grdOn {
	bottom: -4px;
	left: 50%;
	margin-left: -4px;
	-webkit-box-shadow: 1px 1px 4px 0px var(--primary-box-shadow);
	        box-shadow: 1px 1px 4px 0px var(--primary-box-shadow);
	width: 8px;
	height: 8px;
	-webkit-transform: rotate(45deg);
	    -ms-transform: rotate(45deg);
	        transform: rotate(45deg);
	position: absolute;
}

.MapResults-hoveredMarker-PdAKD .MapResults-customMarkerContent-nRGaX {
	color: var(--primary-foreground);
	font-weight: 600;
	background-color: var(--secondary-bg);
	-webkit-box-shadow: none;
	        box-shadow: none;
	z-index: 1000;
}

.MapResults-hoveredMarker-PdAKD .MapResults-customMarkerPoint-QGrmu {
	background-color: var(--secondary-bg);
	z-index: 1000;
}

.MapResults-hoveredMarker-PdAKD .MapResults-customMarkerPointBorder-grdOn {
	-webkit-box-shadow: none;
	        box-shadow: none;
}

.MapResults-searchThisAreaContainer-wlmbR {
	position: absolute;
	bottom: 24px;
	left: 50%;
	-webkit-transform: translateX(-50%);
	    -ms-transform: translateX(-50%);
	        transform: translateX(-50%);
	z-index: 10;
	pointer-events: none;
}

.MapResults-searchThisAreaBtn-ZuKQg {
	background: var(--background-primary);
	border: none;
	border-radius: 24px;
	padding: 10px 24px;
	-webkit-box-shadow: 0 2px 8px var(--primary-box-shadow);
	        box-shadow: 0 2px 8px var(--primary-box-shadow);
	cursor: pointer;
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
	pointer-events: auto;
	-webkit-transition: -webkit-box-shadow 0.2s ease;
	transition: -webkit-box-shadow 0.2s ease;
	transition: box-shadow 0.2s ease;
	transition: box-shadow 0.2s ease, -webkit-box-shadow 0.2s ease;
	white-space: nowrap;
}

.MapResults-searchThisAreaBtn-ZuKQg:hover {
	-webkit-box-shadow: 0 4px 14px var(--primary-box-shadow);
	        box-shadow: 0 4px 14px var(--primary-box-shadow);
}

@media screen and (max-width: 768px) {
	.MapResults-responsiveView-ZAOxP {
		display: none;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/MapResults/MapResults.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,WAAW;CACX,0CAA0C;CAC1C,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,gCAAgC;CAChC,gBAAgB;CAChB,2CAA2C;CAC3C,6DAAqD;SAArD,qDAAqD;CACrD,kBAAkB;CAClB,4BAA4B;CAC5B,8BAA8B;CAC9B,8CAA8C;CAC9C,mCAAgC;IAAhC,gCAAgC;CAChC,8BAA8B;CAC9B,mCAAmC;CACnC,+CAA+C;CAC/C,0BAAkB;CAAlB,uBAAkB;CAAlB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,iBAAiB;CACjB,2CAA2C;CAC3C,UAAU;CACV,WAAW;CACX,gCAAwB;KAAxB,4BAAwB;SAAxB,wBAAwB;CACxB,kBAAkB;CAClB,8CAA8C;CAC9C,8BAA8B;CAC9B,wCAAwC;AACzC;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,iBAAiB;CACjB,6DAAqD;SAArD,qDAAqD;CACrD,UAAU;CACV,WAAW;CACX,gCAAwB;KAAxB,4BAAwB;SAAxB,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,qCAAqC;CACrC,wBAAgB;SAAhB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,qCAAqC;CACrC,aAAa;AACd;;AAEA;CACC,wBAAgB;SAAhB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,mCAA2B;KAA3B,+BAA2B;SAA3B,2BAA2B;CAC3B,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,qCAAqC;CACrC,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,uDAA+C;SAA/C,+CAA+C;CAC/C,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,oBAAoB;CACpB,gDAAgC;CAAhC,wCAAgC;CAAhC,gCAAgC;CAAhC,8DAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,wDAAgD;SAAhD,gDAAgD;AACjD;;AAEA;CACC;EACC,aAAa;CACd;AACD","sourcesContent":[".mapCanvas {\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: var(--secondary-gray-bg);\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.customMarkerContainer {\n\tposition: relative;\n\tdisplay: inline-block;\n\tmargin-top: -8px;\n}\n\n.customMarkerContent {\n\tfont-size: 14px;\n\tline-height: 24px;\n\tletter-spacing: normal;\n\tcolor: var(--primary-foreground);\n\tfont-weight: 500;\n\tbackground-color: var(--background-primary);\n\tbox-shadow: 0px 2px 4px 0px var(--primary-box-shadow);\n\tposition: relative;\n\tborder-width: 1px !important;\n\tborder-style: solid !important;\n\tborder-color: var(--primary-border) !important;\n\tborder-image: initial !important;\n\tborder-radius: 20px !important;\n\tpadding: 4px 8px 4px 8px !important;\n\tfont-family: var(--font-family-base) !important;\n\twidth: max-content;\n}\n\n.customMarkerPoint {\n\tbottom: -4px;\n\tleft: 50%;\n\tmargin-left: -4px;\n\tbackground-color: var(--background-primary);\n\twidth: 8px;\n\theight: 8px;\n\ttransform: rotate(45deg);\n\tposition: absolute;\n\tborder-color: var(--primary-border) !important;\n\tborder-style: solid !important;\n\tborder-width: 0px 1px 1px 0px !important;\n}\n\n.customMarkerPointBorder {\n\tbottom: -4px;\n\tleft: 50%;\n\tmargin-left: -4px;\n\tbox-shadow: 1px 1px 4px 0px var(--primary-box-shadow);\n\twidth: 8px;\n\theight: 8px;\n\ttransform: rotate(45deg);\n\tposition: absolute;\n}\n\n.hoveredMarker .customMarkerContent {\n\tcolor: var(--primary-foreground);\n\tfont-weight: 600;\n\tbackground-color: var(--secondary-bg);\n\tbox-shadow: none;\n\tz-index: 1000;\n}\n\n.hoveredMarker .customMarkerPoint {\n\tbackground-color: var(--secondary-bg);\n\tz-index: 1000;\n}\n\n.hoveredMarker .customMarkerPointBorder {\n\tbox-shadow: none;\n}\n\n.searchThisAreaContainer {\n\tposition: absolute;\n\tbottom: 24px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tz-index: 10;\n\tpointer-events: none;\n}\n\n.searchThisAreaBtn {\n\tbackground: var(--background-primary);\n\tborder: none;\n\tborder-radius: 24px;\n\tpadding: 10px 24px;\n\tbox-shadow: 0 2px 8px var(--primary-box-shadow);\n\tcursor: pointer;\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tline-height: 18px;\n\tpointer-events: auto;\n\ttransition: box-shadow 0.2s ease;\n\twhite-space: nowrap;\n}\n\n.searchThisAreaBtn:hover {\n\tbox-shadow: 0 4px 14px var(--primary-box-shadow);\n}\n\n@media screen and (max-width: 768px) {\n\t.responsiveView {\n\t\tdisplay: none;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapCanvas": `MapResults-mapCanvas-hgyBU`,
	"customMarkerContainer": `MapResults-customMarkerContainer-xtoUN`,
	"customMarkerContent": `MapResults-customMarkerContent-nRGaX`,
	"customMarkerPoint": `MapResults-customMarkerPoint-QGrmu`,
	"customMarkerPointBorder": `MapResults-customMarkerPointBorder-grdOn`,
	"hoveredMarker": `MapResults-hoveredMarker-PdAKD`,
	"searchThisAreaContainer": `MapResults-searchThisAreaContainer-wlmbR`,
	"searchThisAreaBtn": `MapResults-searchThisAreaBtn-ZuKQg`,
	"responsiveView": `MapResults-responsiveView-ZAOxP`
};
module.exports = ___CSS_LOADER_EXPORT___;
